import { useState } from 'react';
import styled from 'styled-components';

import EngagementByTile from '../components/Engagement/EngagementByTile.jsx';
import { Feedback } from '../campaigns/components/Feedback.jsx';
import { Survey } from '../campaigns/components/Survey.jsx';
import { Quiz } from '../campaigns/components/Quiz.jsx';
import QaReports from '../qaTiles/QaReports.jsx';
import useSort from '../../../shared/Sort/useSort';
import { useCampaignFilter } from '../hooks/useCampaignFilter';
import Tooltip from '../../../shared/Tooltip';
import { TILE_TYPES } from '../constants';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const AllTilesReports = ({ tileType = TILE_TYPES.ALL }) => {
  const {
    sortingStatus: engagementSortingStatus,
    changeSort: changeEngagementSort,
  } = useSort();
  const [showAll, setShowAll] = useState(false);
  const { campaignId } = useCampaignFilter();

  const renderContent = () => {
    switch (tileType) {
      case TILE_TYPES.FEEDBACK:
        return (
          <Feedback
            campaignId={campaignId}
            showAll={showAll}
            sortingStatus={engagementSortingStatus}
            changeSort={changeEngagementSort}
            onClick={() => setShowAll(prev => !prev)}
          />
        );
      case TILE_TYPES.SURVEY:
        return (
          <Survey
            campaignId={campaignId}
            showAll={showAll}
            sortingStatus={engagementSortingStatus}
            changeSort={changeEngagementSort}
            onClick={() => setShowAll(prev => !prev)}
          />
        );
      case TILE_TYPES.QUIZ:
        return (
          <Quiz
            campaignId={campaignId}
            showAll={showAll}
            sortingStatus={engagementSortingStatus}
            changeSort={changeEngagementSort}
            onClick={() => setShowAll(prev => !prev)}
          />
        );
      case TILE_TYPES.QA:
        return <QaReports />;
      case TILE_TYPES.ALL:
      default:
        return (
          <EngagementByTile
            sortingStatus={engagementSortingStatus}
            changeSort={changeEngagementSort}
            showAll={showAll}
            setShowAll={() => setShowAll(state => !state)}
            campaignId={campaignId}
          />
        );
    }
  };

  return (
    <Wrapper>
      <Tooltip />
      {renderContent()}
    </Wrapper>
  );
};

export default AllTilesReports;
